import { useState } from "react";
const UserAnalyticsReadOnlyRow = ({ index, t, userAnalyticsItem, handleDeleteClick, oddIdx, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, userAnalyticsItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, userAnalyticsItem, submitComplete);
	}

	function handleEditClick(event) {
		//event.preventDefault();
		//event.stopPropagation();
		setIsSubmit(false);
	}

	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userAnalyticsItem.analyticsDescription}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{userAnalyticsItem.status}</td>

			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<>
					<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, userAnalyticsItem)}>
						{userAnalyticsItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
				</>

			</td>
		</tr>
	)
}
export default UserAnalyticsReadOnlyRow;